export const categoriesData = [
  {
    categoryName: 'Psychic Readings',
    description:
      'Psychic readers can provide peace of mind, insight on relationships and closure, but they are also an opportunity to boost your confidence.',
    link: '/psychic-readings/195',
    iconName: 'catReadingGlobe'
  },
  {
    categoryName: 'Psychic Mediums',
    description:
      'Whether you are seeking comfort, closure, or to resolve unanswered questions through a medium reading, a medium can help you communicate with a deceased loved one.',
    link: '/psychic-readings/psychic-mediums/754',
    iconName: 'catPsychicMediums'
  },
  {
    categoryName: 'Financial Guidance',
    description:
      'Financial issues can be stressful. Careers take unexpected turns. Speak to a psychic to see if your financial outlook will improve.',
    link: '/psychic-readings/financial-guidance/705',
    iconName: 'catFinancialOutlook'
  },
  {
    categoryName: 'Love and Relationships',
    description:
      'While all psychics can discuss matters of the heart, relationship experts have a special knack for being in tune with the romantic vibrations when providing love readings.',
    link: '/psychic-readings/love-relationships/635',
    iconName: 'catLoveAndRelationships'
  },
  {
    categoryName: 'Life Path & Advice',
    description:
      'Get the clarity you need to move forward with important life decisions such as a career change, a big move, soul purpose, and more.',
    link: '/psychic-readings/life-path-advice/636',
    iconName: 'catLifeQuestions'
  },
  {
    categoryName: 'Tarot Card Readings',
    description:
      'Tarot readings use the 78 tarot cards to try to obtain a deeper understanding of the past, present, and future.',
    link: '/psychic-readings/tarot-card-readings/588',
    iconName: 'catTarotReadings'
  },
  {
    categoryName: 'Spiritual Readings',
    description:
      'Take a journey of self-discovery and learn how you can be more mindful, present, and balanced in life. Discover the things that make you happy in life so that you can find your purpose.',
    link: '/psychic-readings/spiritual-readings/200',
    iconName: 'catSpiritualReadings'
  },
  {
    categoryName: 'Astrology Readings',
    description:
      'Your birth chart can tell more about your life than you may realize. Gain insight on what you need to do in order to be your best self in the present and in the future.',
    link: '/psychic-readings/astrology-readings/196',
    iconName: 'catAstrologyAdvice'
  }
];

export default categoriesData;
